import React, { useEffect, useState } from 'react';
import { Form, Input, Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { SERVER_IP } from 'assets/Config';
import { resetApiStatus, setSelectedOrganization } from 'redux/reducers/globals/globalActions';
import { putApi } from 'redux/sagas/putApiSaga';
import { sendGetRequest } from 'redux/sagas/utils';
import { buildOrgPayload, OrgAddressFields } from './add-organization';

const EditOrganization = ({ closeModal, onUpdated }) => {
	const globalRedux = useSelector((state) => state.globalRedux);
	const dispatch = useDispatch();
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(true);
	const orgId = globalRedux?.selectedOrganization?._id;

	useEffect(() => {
		const loadOrg = async () => {
			if (!orgId) return;
			setLoading(true);
			const { data, status } = await sendGetRequest(
				null,
				`${SERVER_IP}organization/${orgId}`
			);
			if (status === 200 && data) {
				form.setFieldsValue({
					orgName: data.orgName,
					gstin: data.gstin,
					location: data.location,
					invoicePrefix: data.invoicePrefix,
					addressLine1: data.addressDetails?.addressLine1,
					addressLine2: data.addressDetails?.addressLine2,
					city: data.addressDetails?.city,
					pincode: data.addressDetails?.pincode,
					state: data.addressDetails?.state,
					country: data.addressDetails?.country || 'India',
					contact: data.addressDetails?.contact,
				});
			}
			setLoading(false);
		};
		loadOrg();
	}, [orgId, form]);

	useEffect(() => {
		if (globalRedux.apiStatus.EDIT_ORGANIZATION === 'SUCCESS') {
			const refreshOrg = async () => {
				const { data, status } = await sendGetRequest(
					null,
					`${SERVER_IP}organization/${orgId}`
				);
				if (status === 200 && data) {
					dispatch(setSelectedOrganization({ ...data, _id: data._id || orgId }));
					onUpdated?.(data);
				}
			};
			refreshOrg();
			dispatch(resetApiStatus('EDIT_ORGANIZATION'));
			closeModal?.();
		}
	}, [globalRedux.apiStatus.EDIT_ORGANIZATION]);

	const onSubmit = (values) => {
		dispatch(
			putApi(
				buildOrgPayload(values),
				'EDIT_ORGANIZATION',
				`${SERVER_IP}organization/${orgId}`
			)
		);
	};

	return (
		<Form
			style={{ padding: '0 20px' }}
			className="custom-form"
			requiredMark={false}
			colon={false}
			layout="vertical"
			labelAlign="left"
			form={form}
			onFinish={onSubmit}
		>
			<Form.Item
				label="Organization Name"
				name="orgName"
				rules={[{ required: true, message: 'This Field is Required!' }]}
			>
				<Input disabled={loading} />
			</Form.Item>

			<Form.Item
				label="GSTIN"
				name="gstin"
				rules={[{ required: true, message: 'This Field is Required!' }]}
			>
				<Input disabled={loading} />
			</Form.Item>

			<OrgAddressFields />

			<Form.Item>
				<Button
					loading={
						loading || globalRedux.apiStatus.EDIT_ORGANIZATION === 'PENDING'
					}
					disabled={loading}
					type="primary"
					style={{ marginRight: '10px' }}
					htmlType="submit"
				>
					Update
				</Button>
				<Button onClick={closeModal} danger>
					Cancel
				</Button>
			</Form.Item>
		</Form>
	);
};

export default EditOrganization;
